/**
 * Created by lihanying on 2017/7/1.
 */
import React from 'react'
import CommodityStorage from './commodityStorage'
import CommodityInfo from './commodityInfo'
import { ContactsOutlined, IdcardOutlined } from '@ant-design/icons'
import { Modal, Tabs, Spin } from 'antd'
const TabPane = Tabs.TabPane

export default class extends React.Component {
  state = {
    tabIndex: 1,
  }

  onTabClick = (value) => {
    console.log('value', value)
    this.setState({
      tabIndex: value,
    })
  }

  render() {
    const {
      visible,
      record,
      commodityType,
      qiniuToken,
      imageUrl,
      inStorage,
      commodityTotal,
      total_c,
      loading,
    } = this.props

    const { tabIndex } = this.state
    return (
      <div>
        <Modal
          title={record.commodity_name}
          visible={visible}
          onOk={this.props.handleOk}
          onCancel={this.props.handleCancel}
          width={tabIndex != 1 ? '1500px' : '1250px'}
        >
          <div>
            {loading ? (
              <Spin
                tip="正在加载..."
                className="level-loading"
                style={{ textAlign: 'center' }}
              />
            ) : (
              <Tabs defaultActiveKey="1" onTabClick={this.onTabClick}>
                <TabPane
                  tab={
                    <span>
                      <IdcardOutlined />
                      商品信息
                    </span>
                  }
                  key="1"
                >
                  <CommodityInfo
                    record={record}
                    qiniuToken={qiniuToken}
                    imageUrl={imageUrl}
                    commodityType={commodityType}
                    commodityTotal={commodityTotal}
                    total_c={total_c}
                    fetchQiniu={this.props.fetchQiniu}
                    getImageUrl={this.props.getImageUrl}
                    handleEditCheckbox={this.props.handleEditCheckbox}
                  />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <ContactsOutlined />
                      进销存
                    </span>
                  }
                  key="2"
                >
                  <CommodityStorage
                    record={record}
                    storage={inStorage}
                    fetchRemoveFreeze={this.props.fetchRemoveFreeze}
                  />
                </TabPane>
              </Tabs>
            )}
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/component/modalDetail.js